 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTTITLEPAGE from '@/components/Text/titlepage'
 import TEXTEPIGRAPH from '@/components/Text/epigraph'
 import TEXTCONTENTS from '@/components/Text/contents'
 import TEXTPREFACE from '@/components/Text/preface'
 import TEXTPT1 from '@/components/Text/pt1'
 import TEXTCH1 from '@/components/Text/ch1'
 import TEXTCH2 from '@/components/Text/ch2'
 import TEXTPT2 from '@/components/Text/pt2'
 import TEXTCH3 from '@/components/Text/ch3'
 import TEXTCH4 from '@/components/Text/ch4'
 import TEXTCH5 from '@/components/Text/ch5'
 import TEXTCH6 from '@/components/Text/ch6'
 import TEXTCH7 from '@/components/Text/ch7'
 import TEXTEPILOGUE from '@/components/Text/epilogue'
 import TEXTAFTERWORD from '@/components/Text/afterword'
 import TEXTBIBLIOGRAPHY from '@/components/Text/bibliography'
 import TEXTILLUSTRATIONS from '@/components/Text/illustrations'
 import TEXTNOTES from '@/components/Text/notes'
 import TEXTGENERALINDEX from '@/components/Text/generalindex'
 import TEXTSCRIPTUREINDEX from '@/components/Text/scriptureindex'
 import TEXTPRAISE from '@/components/Text/praise'
 import TEXTAUTHORS from '@/components/Text/authors'
 import TEXTBRANDPAGE from '@/components/Text/brandpage'
 import TEXTMOREIVP from '@/components/Text/moreIVP'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/contents",
 			"name" : "Text/contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/preface",
 			"name" : "Text/preface",
 			"component" : TEXTPREFACE
 		},
 		{
 			"path" : "/Text/pt1",
 			"name" : "Text/pt1",
 			"component" : TEXTPT1
 		},
 		{
 			"path" : "/Text/ch1",
 			"name" : "Text/ch1",
 			"component" : TEXTCH1
 		},
 		{
 			"path" : "/Text/ch2",
 			"name" : "Text/ch2",
 			"component" : TEXTCH2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js